import { render } from "./CreditHistoryComponent.vue?vue&type=template&id=19d328a0&scoped=true"
import script from "./CreditHistoryComponent.vue?vue&type=script&lang=js"
export * from "./CreditHistoryComponent.vue?vue&type=script&lang=js"

import "./CreditHistoryComponent.vue?vue&type=style&index=0&id=19d328a0&scoped=true&lang=css"

import exportComponent from "/home/runner/work/FONSNTE/FONSNTE/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19d328a0"]])

export default __exports__